import { render, staticRenderFns } from "./xsbd.vue?vue&type=template&id=78dd6272"
import script from "./xsbd.vue?vue&type=script&lang=js"
export * from "./xsbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports